export const removeKeyFromObject = <T extends object>(obj: T, key: keyof T) => {
	const newObj = { ...obj };
	delete newObj[key];
	return newObj;
};

export const isNullOrEmptyObject = (obj: unknown) => {
	if (obj === null || obj === undefined) {
		return true;
	}
	return typeof obj === "object" && Object.keys(obj).length === 0;
};

export const isNotNullOrEmptyObject = (obj: unknown): obj is object => {
	return !isNullOrEmptyObject(obj);
};
